import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import {
  ITrackingAction,
  ITrackingObject,
} from '../../../tracking/tracking.data';
import { TrackingDispatcher } from '../../../tracking/tracking.dispatcher';

@Directive({
  selector: '[trackable]',
})
export class TrackableDirective implements OnInit {
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;
  @Input() trackingAdditionalProperties: any;

  private _el: any;

  constructor(
    private _elementRef: ElementRef,
    private _trackingDispatcher: TrackingDispatcher
  ) {}

  ngOnInit() {
    this._el = this._elementRef.nativeElement;
  }

  @HostListener('click', ['$event'])
  onClickEvent(evt: Event) {
    if (this.trackingObject && this.trackingAction) {
      this._trackingDispatcher.trackEvent(
        this.trackingObject,
        this.trackingAction,
        this.trackingAdditionalProperties
      );
    }
  }
}
